import classNames from 'classnames';
import { forwardRef } from 'react';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { SharedIcon, SharedIconProps } from 'components/SharedIcon/SharedIcon';

interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  iconProps: SharedIconProps;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ iconProps, onClick, className, ...props }, ref) => (
    <StylishNewButton
      ref={ref}
      className={classNames(
        'button--icon border-0 bg-bglight-hover',
        className
      )}
      onClick={onClick}
      {...props}
    >
      <SharedIcon {...iconProps} size="sm" />
    </StylishNewButton>
  )
);

IconButton.displayName = 'IconButton';
